/** Query keys of the console, in one place. */
export const keys = {
  organizations: ['console', 'organizations'] as const,
  organization: (id: string) => ['console', 'organizations', id] as const,
  modules: (id: string) => ['console', 'organizations', id, 'modules'] as const,
  moduleRequests: (status: string) => ['console', 'module-requests', status] as const,
  members: ['console', 'members'] as const,
  audit: (own: boolean, action: string, page: number) =>
    ['console', 'audit', own, action, page] as const,
  smtp: ['console', 'smtp'] as const,
  retention: ['console', 'retention'] as const,
  support: ['console', 'support'] as const,
};
